

























import { Vue, Component, Prop } from 'vue-property-decorator';
import T from '../../lang';

@Component
export default class Slide extends Vue {
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() imageSrc!: string;
  @Prop() button!: {
    text: {
      en: string;
      es: string;
      pt: string;
    };
    href: string;
    target: string;
  };

  T = T;
}
